"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference path="../types/Jsts.ts" />
var LineString_1 = __importDefault(require("./LineString"));
var GeometryCollectionBase_1 = __importDefault(require("./GeometryCollectionBase"));
var GeometryType_1 = require("./GeometryType");
var Geometry_1 = __importDefault(require("./Geometry"));
var MultiLineString = /** @class */ (function (_super) {
    __extends(MultiLineString, _super);
    function MultiLineString(lines) {
        return _super.call(this, lines) || this;
    }
    Object.defineProperty(MultiLineString.prototype, "type", {
        get: function () {
            return GeometryType_1.GeometryType.MultiLineString;
        },
        enumerable: true,
        configurable: true
    });
    MultiLineString.prototype._ts = function () {
        return Geometry_1.default._factory.createMultiLineString(this.children.map(function (l) { return l._ts(); }));
    };
    MultiLineString.prototype._clone = function (convert) {
        return new MultiLineString(this._cloneChildren(convert));
    };
    MultiLineString._from = function (multiline) {
        var geom = new MultiLineString();
        var geomCount = multiline.getNumGeometries();
        for (var i = 0; i < geomCount; i++) {
            geom.children.push(LineString_1.default._from(multiline.getGeometryN(i)));
        }
        return geom;
    };
    return MultiLineString;
}(GeometryCollectionBase_1.default));
exports.default = MultiLineString;
